// Proctoring guidance shown on the assessment INSTRUCTION pages (aptitude,
// communication, role-based, behaviour, hinglish, custom). Same content as the
// BiometricCheck "How to take this honestly" panel, surfaced earlier so the
// candidate sees the eye-contact / stay-in-frame / no-phone rules up front.
// NOT used for AI Interview (its instruction screen intentionally omits this).
//
// Self-contained (own styled-components + icons from AssessmentIcons) so it can
// drop into any instruction page with a single import + <ProctoringGuidelines />.
// Renders nothing when proctoring is disabled for the assessment.
import React from 'react'
import styled from 'styled-components'
import { Shield, Monitor, BookOpen, UserCheck, Hand, Camera } from './icons/AssessmentIcons'

const Panel = styled.div`
  width: 100%;
  margin: 16px 0;
  padding: 16px 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  text-align: left;
`
const Heading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 12px;
`
const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 10px;
  display: flex;
  flex-direction: column;
  gap: 9px;
`
const Item = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 12.5px;
  color: #374151;
  line-height: 1.45;
  & > svg { flex-shrink: 0; margin-top: 1px; color: #2563eb; }
`
const Note = styled.p`
  margin: 8px 0 0;
  font-size: 11.5px;
  color: #6b7280;
`

export default function ProctoringGuidelines({ proctoringEnabled = true }) {
  if (!proctoringEnabled) return null
  return (
    <Panel>
      <Heading>
        <Shield size={16} /> How to take this assessment honestly
      </Heading>
      <List>
        <Item>
          <Monitor size={15} />
          <span>Keep your eyes on the screen and stay facing the camera. Looking away for long reads as distracted.</span>
        </Item>
        <Item>
          <BookOpen size={15} />
          <span>Don't read from notes, a phone, or anything below the screen. Looking down for more than a few seconds is flagged.</span>
        </Item>
        <Item>
          <UserCheck size={15} />
          <span>Stay alone in the frame. No one else should appear on camera during the assessment.</span>
        </Item>
        <Item>
          <Hand size={15} />
          <span>Don't use or pick up a phone. Phone detection runs throughout the assessment.</span>
        </Item>
        <Item>
          <Camera size={15} />
          <span>Keep your camera on the whole time, your face centered and well-lit. The assessment pauses if your camera turns off.</span>
        </Item>
      </List>
      <Note>
        Integrity is reviewed afterwards and will not interrupt your assessment — just stay focused and honest.
      </Note>
    </Panel>
  )
}
